import React from 'react';
import { Link } from 'react-router-dom';
import '../../assets/css/home.css';
import spiderLogo from '../../assets/images/logo2.png';

const HomePage = () => {
    return (
        <div className="home-container">
            <div className="home-content">
                <div className="logo-container">
                    <h1 className="game-title">Spider Solitaire</h1>
                    <div className="spider-logo">
                        <img src={spiderLogo} alt="Spider Logo" />
                    </div>
                </div>
                
                <div className="menu-buttons">
                    <Link to="/game">
                        <button className="menu-btn start-btn">
                            Start Game
                        </button>
                    </Link>
                    
                    <Link to="/highscores">
                        <button className="menu-btn highscore-btn">
                            High Scores
                        </button>
                    </Link>
                    
                    <Link to="/about">
                        <button className="menu-btn about-btn">
                            About
                        </button>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default HomePage; 